import type { SVGProps } from 'react';

interface TiktokIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const TiktokIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & TiktokIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 25 25"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <rect fill="#4FA9FF" height={25} rx={12.5} width={25} />
    <g clipPath="url(#tiktok_svg__a)">
      <path
        d="M17.486 9.776a3 3 0 0 1-.98-.371 3.5 3.5 0 0 1-.826-.68q-.714-.796-.826-1.917V6.5h-2.408v9.562q0 .644-.385 1.183-.384.539-1 .742-.617.202-1.247.007a1.97 1.97 0 0 1-1.015-.707 2 2 0 0 1-.399-1.19q-.014-.68.364-1.197.351-.532 1.008-.756.603-.21 1.26-.014v-2.45a4.3 4.3 0 0 0-1.365.02q-.678.12-1.302.442a4.3 4.3 0 0 0-1.106.819 4.4 4.4 0 0 0-.79 1.113q-.309.615-.42 1.302a4.2 4.2 0 0 0 0 1.372q.111.685.42 1.309a4.33 4.33 0 0 0 1.826 1.904q.582.316 1.225.448.645.133 1.302.07a4.5 4.5 0 0 0 1.267-.308 4.4 4.4 0 0 0 1.127-.665q.519-.42.882-.966a4.5 4.5 0 0 0 .56-1.176q.196-.63.196-1.288v-4.9a5.7 5.7 0 0 0 3.346 1.078V9.846q-.42 0-.714-.07"
        fill="#F8F8F8"
      />
    </g>
    <defs>
      <clipPath id="tiktok_svg__a">
        <path d="M5.99 20.5H19v-14H5.99z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
